import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import NextGenerationSection from './components/NextGenerationSection';
import SchoolSection from './components/SchoolSection';
import GiveSection from './components/GiveSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative bg-black text-white">
      <Navbar scrolled={scrolled} />
      <HeroSection />
      <NextGenerationSection />
      <SchoolSection />
      <GiveSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
